import { NgModule } from '@angular/core';
import { DragDropFilesDirective } from './drag-drop-files.directive';
import { StopChangePropagationDirective } from './stop-change-propagation.directive';

@NgModule({
    declarations: [
        StopChangePropagationDirective,
        DragDropFilesDirective
    ],
    exports: [
        StopChangePropagationDirective,
        DragDropFilesDirective
    ]

})
export class DirectivesModule {

}



// WEBPACK FOOTER //
// ./src/app/directives/directives.module.ts